import React from "react";
import "./promo.scss";
import penawaran from "../../media/hardsell_promo.webp";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckDouble} from "@fortawesome/free-solid-svg-icons";

const Penawaran = () => {
  const handleConsultationClick = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6281297520392&text=Halo+Jason%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20produk%20Hiera%20(Promo)%20https://www.bsdcity-hiera.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div className="judulpromo">
      <div id="promo" className="judul">
        <h1>OUR PROMO</h1>
      </div>
      <div id="promo" className=" containerPenawaran">
        <div className="containercontent">
          <div className="pointpenawaran">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "rgb(70, 70, 70)"}}>
                &nbsp;&nbsp;Free DP
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "rgb(70, 70, 70)"}}>
                &nbsp;&nbsp;Discount Up to 12%
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "rgb(70, 70, 70)"}}>
                &nbsp;&nbsp;Free Kitchen Set
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "rgb(70, 70, 70)"}}>
                &nbsp;&nbsp;Free AC
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "rgb(70, 70, 70)"}}>
                &nbsp;&nbsp;Sanitary by GROHE
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "rgb(70, 70, 70)"}}>
                &nbsp;&nbsp;Full Marble
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "rgb(70, 70, 70)"}}>
                &nbsp;&nbsp;Free IPL
              </span>
            </div>
          </div>

          <button className="buttonpenawaran" onClick={handleConsultationClick}>
            Learn More
          </button>
        </div>
        <div className="containergambar">
          <img className="penawarangambar" src={penawaran} alt={penawaran} />
        </div>
      </div>
    </div>
  );
};

export default Penawaran;
